import { CounterText } from './CharacterCounter.styles';
import { TCharacterCounterProps } from './types';

const CharacterCounter = ({ current, max, isAtLimit }: TCharacterCounterProps) => (
  <CounterText $isAtLimit={isAtLimit} aria-live="polite" aria-atomic="true" data-testid="character-counter">
    {current}/{max}
  </CounterText>
);

export default CharacterCounter;
